import { Action } from 'redux';
import { OptionsObject } from 'notistack';

export interface Notification {
  key: number;
  message: string;
  options?: OptionsObject;
}

export interface SnacksState {
  notifications: Notification[];
}

export enum SnacksActionTypes {
  ADD_SNACKBAR = '@@snacks/ADD_SNACKBAR',
  CLEAR_SNACKBAR = '@@snacks/CLEAR_SNACKBAR',
}

export interface SnacksAction extends Action<SnacksActionTypes> {
  notification?: Notification;
  notificationKey?: number;
}
